import React from 'react';
import '../template-file-css/document-file-template.css';


export const SSS_PsychiatricEvaluation = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='SSS_PsychiatricEvaluation' className='file-pdf-document'>
            <div className='file-template'>

                <table>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'> Client Name:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Date of Birth:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtClientName' name='txtClientName' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtDateofBirth' name='txtDateofBirth' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Date of Service:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='date' id='txtDateofService' name='txtDateofService' className='add-only' /> </td>
                        <td className='w-250'><input type='checkbox' id='cbDateofService_1' name='cbDateofService_1' className='add-only' value='TELEHEALTH' /> TELEHEALTH </td>
                        <td className='w-250'><input type='checkbox' id='cbDateofService_2' name='cbDateofService_2' className='add-only' value='IN-PERSON' /> IN-PERSON </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Gender:</span></td>
                    </tr>
                    <tr>
                        <td className='w-100'><input type='radio' id='rbGender_Male' name='rbGender' className='add-only' value='0' /> Male </td>
                        <td className='w-100'><input type='radio' id='rbGender_Female' name='rbGender' className='add-only' value='1' /> Female </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'> Race/Ethnicity:</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbRace_2' name='cbRace_2' className='add-only' value=' BLACK/AA' /> BLACK/AA</td>
                        <td className='w-187'><input type='checkbox' id='cbRace_3' name='cbRace_3' className='add-only' value=' WHITE' /> WHITE </td>
                        <td className='w-187'><input type='checkbox' id='cbRace_4' name='cbRace_4' className='add-only' value=' H/LATINO' /> H/LATINO </td>
                        <td className='w-187'><input type='checkbox' id='cbRace_5' name='cbRace_5' className='add-only' value=' ASIAN' /> ASIAN </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRace_1' name='cbRace_1' className='add-only' value=' OTHER' /> OTHER:
                            &nbsp;
                            <input type='text' id='txtOther' name='txtOther' className='add-only custom-add-only w-250' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Type of Service:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            Psychiatric Assessment Start Time: &nbsp;
                            <input type='time' id='txtPsychiatricAssessment_1' name='txtPsychiatricAssessment_1' className='add-only w-100 custom-add-only' /> Stop Time: &nbsp;
                            <input type='time' id='txtPsychiatricAssessment_2' name='txtPsychiatricAssessment_2' className='add-only w-100 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Individuals Involved:</span>
                    <textarea id='txtIndividualsInvolved' name='txtIndividualsInvolved' className='add-only'></textarea>
                    <span className='eleHeader'>GENERAL INFORMATION:</span>
                    <input type='text' id='GENERALINFORMATION_1' name='GENERALINFORMATION_1' className='add-only w-100 custom-add-only' /> years old &nbsp;
                    <input type='text' id='GENERALINFORMATION_2' name='GENERALINFORMATION_2' className='add-only w-100 custom-add-only' /> Grade
                </p>


                <p className='w-750'>
                    <span className='eleHeader'> CHIEF COMPLAINT/PRESENTING PROBLEMS:</span>
                    <textarea id='txtCOMPLAINT' name='txtCOMPLAINT' className='add-only'></textarea>

                    <span className='eleHeader'> DESCRIBE BEHAVIORS/IMPAIRED FUNCTIONAL STATUS:</span>
                    <textarea id='txtDESCRIBEBEHAVIORS' name='txtDESCRIBEBEHAVIORS' className='add-only'></textarea>

                    <span className='eleHeader'> NATURE/FREQUENCY/EXTENT/SEVERITY/DUDRATION:</span>
                    <textarea id='txtNATURE' name='txtNATURE' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><b>MENTAL STAUS EXAMINATION </b> (Check all that apply)</td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>ORIENTATION/SENSORIUM/COGNITION</span> </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbSENSORIUM_1' name='cbSENSORIUM_1' className='add-only' value=' Alert' /> Alert </td>
                        <td className='w-187'><input type='checkbox' id='cbSENSORIUM_2' name='cbSENSORIUM_2' className='add-only' value=' Lethargic' /> Lethargic </td>
                        <td className='w-187'><input type='checkbox' id='cbSENSORIUM_3' name='cbSENSORIUM_3' className='add-only' value=' Somnolent' /> Somnolent </td>
                        <td className='w-187'><input type='checkbox' id='cbSENSORIUM_4' name='cbSENSORIUM_4' className='add-only' value=' Stuporous' /> Stuporous </td>
                    </tr>

                    <tr>
                        <td className='w-750'><b> Oriented to: </b></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbOrientedto_1' name='cbOrientedto_1' className='add-only' value=' Person' /> Person </td>
                        <td className='w-187'><input type='checkbox' id='cbOrientedto_2' name='cbOrientedto_2' className='add-only' value=' Place' /> Place </td>
                        <td className='w-187'><input type='checkbox' id='cbOrientedto_3' name='cbOrientedto_3' className='add-only' value=' Time' /> Time </td>
                        <td className='w-187'><input type='checkbox' id='cbOrientedto_4' name='cbOrientedto_4' className='add-only' value=' Situation' /> Situation </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbOrientedto_5' name='cbOrientedto_5' className='add-only' value=' Normal Concentration' /> Normal Concentration </td>
                        <td className='w-187'><input type='checkbox' id='cbOrientedto_7' name='cbOrientedto_7' className='add-only' value=' Impaired Concentration' />  Impaired Concentration </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOrientedto_6' name='cbOrientedto_6' className='add-only' value=' Other' />  Other:
                            &nbsp;
                            <input type='text' id='txtOther_1' name='txtOther_1' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>GENERAL APPERANCE</span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbGENERALAPPERANCE_1' name='cbGENERALAPPERANCE_1' className='add-only' value=' Healthy' /> Healthy </td>
                        <td className='w-150'><input type='checkbox' id='cbGENERALAPPERANCE_2' name='cbGENERALAPPERANCE_2' className='add-only' value=' Overweight' /> Overweight </td>
                        <td className='w-150'><input type='checkbox' id='cbGENERALAPPERANCE_3' name='cbGENERALAPPERANCE_3' className='add-only' value=' Thin' /> Thin </td>
                        <td className='w-150'><input type='checkbox' id='cbGENERALAPPERANCE_4' name='cbGENERALAPPERANCE_4' className='add-only' value=' Obese' /> Obese </td>
                        <td className='w-150'><input type='checkbox' id='cbGENERALAPPERANCE_5' name='cbGENERALAPPERANCE_5' className='add-only' value=' Unkempt' /> Unkempt </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbGENERALAPPERANCE_6' name='cbGENERALAPPERANCE_6' className='add-only' value=' As Stated Age' /> As Stated Age </td>

                        <td className='w-150'><input type='checkbox' id='cbGENERALAPPERANCE_7' name='cbGENERALAPPERANCE_7' className='add-only' value='Disheveled' /> Disheveled </td>
                        <td className='w-150'><input type='checkbox' id='cbGENERALAPPERANCE_8' name='cbGENERALAPPERANCE_8' className='add-only' value=' Young-looking' /> Young-looking </td>
                        <td className='w-150'><input type='checkbox' id='cbGENERALAPPERANCE_9' name='cbGENERALAPPERANCE_9' className='add-only' value=' Emaciated' /> Emaciated </td>
                        <td className='w-150'><input type='checkbox' id='cbGENERALAPPERANCE_10' name='cbGENERALAPPERANCE_10' className='add-only' value=' Tattoos' /> Tattoos </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbGENERALAPPERANCE_11' name='cbGENERALAPPERANCE_11' className='add-only' value=' Malodorous' /> Malodorous </td>
                        <td className='w-150'><input type='checkbox' id='cbGENERALAPPERANCE_12' name='cbGENERALAPPERANCE_12' className='add-only' value=' Poor-Hygiene' /> Poor-Hygiene </td>
                        <td className='w-300'><input type='checkbox' id='cbGENERALAPPERANCE_13' name='cbGENERALAPPERANCE_13' className='add-only' value=' Older Than Stated Age' /> Older Than Stated Age </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbGENERALAPPERANCE_14' name='cbGENERALAPPERANCE_14' className='add-only' value=' Other' /> Other:
                            &nbsp;
                            <input type='text' id='txtOther_2' name='txtOther_2' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>FACIAL EXPRESSION</span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbFACIALEXPRESSION_1' name='cbFACIALEXPRESSION_1' className='add-only' value=' Appropriate to topic' /> Appropriate to topic </td>
                        <td className='w-150'><input type='checkbox' id='cbFACIALEXPRESSION_2' name='cbFACIALEXPRESSION_2' className='add-only' value=' Sad' /> Sad </td>
                        <td className='w-150'><input type='checkbox' id='cbFACIALEXPRESSION_3' name='cbFACIALEXPRESSION_3' className='add-only' value=' Worried' /> Worried </td>
                        <td className='w-150'><input type='checkbox' id='cbFACIALEXPRESSION_4' name='cbFACIALEXPRESSION_4' className='add-only' value=' ObExpressionlessese' /> Expressionless </td>
                        <td className='w-150'><input type='checkbox' id='cbFACIALEXPRESSION_5' name='cbFACIALEXPRESSION_5' className='add-only' value=' Hostile' /> Hostile </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>BEHAVIOR & PSYCHOMOTOR ACTIVITY</span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbPSYCHOMOTORACTIVITY_1' name='cbPSYCHOMOTORACTIVITY_1' className='add-only' value=' Normal' /> Normal </td>
                        <td className='w-150'><input type='checkbox' id='cbPSYCHOMOTORACTIVITY_2' name='cbPSYCHOMOTORACTIVITY_2' className='add-only' value=' Overactive' /> Overactive </td>
                        <td className='w-150'><input type='checkbox' id='cbPSYCHOMOTORACTIVITY_3' name='cbPSYCHOMOTORACTIVITY_3' className='add-only' value=' Hypoactive' /> Hypoactive </td>
                        <td className='w-150'><input type='checkbox' id='cbPSYCHOMOTORACTIVITY_4' name='cbPSYCHOMOTORACTIVITY_4' className='add-only' value=' Catatonia' /> Catatonia </td>
                        <td className='w-150'><input type='checkbox' id='cbPSYCHOMOTORACTIVITY_5' name='cbPSYCHOMOTORACTIVITY_5' className='add-only' value=' Abnormal Gait' /> Abnormal Gait </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbPSYCHOMOTORACTIVITY_7' name='cbPSYCHOMOTORACTIVITY_7' className='add-only' value=' Combative' /> Combative </td>
                        <td className='w-150'><input type='checkbox' id='cbPSYCHOMOTORACTIVITY_8' name='cbPSYCHOMOTORACTIVITY_8' className='add-only' value=' Repetitive Actions' /> Repetitive Actions </td>
                        <td className='w-150'><input type='checkbox' id='cbPSYCHOMOTORACTIVITY_9' name='cbPSYCHOMOTORACTIVITY_9' className='add-only' value=' Tremor' /> Tremor </td>
                        <td className='w-150'><input type='checkbox' id='cbPSYCHOMOTORACTIVITY_10' name='cbPSYCHOMOTORACTIVITY_10' className='add-only' value=' Tics' /> Tics </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbPSYCHOMOTORACTIVITY_6' name='cbPSYCHOMOTORACTIVITY_6' className='add-only' value=' Other' /> Other:
                            &nbsp;
                            <input type='text' id='txtOther_3' name='txtOther_3' className='add-only  w-250 custom-add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>DRESS</span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbDRESS_1' name='cbDRESS_1' className='add-only' value=' Appropriate' /> Appropriate </td>
                        <td className='w-150'><input type='checkbox' id='cbDRESS_2' name='cbDRESS_2' className='add-only' value=' Eccentric/Bizarre' /> Eccentric/Bizarre </td>
                        <td className='w-150'><input type='checkbox' id='cbDRESS_3' name='cbDRESS_3' className='add-only' value=' Seductive' /> Seductive </td>
                        <td className='w-150'><input type='checkbox' id='cbDRESS_4' name='cbDRESS_4' className='add-only' value=' Meticulous' /> Meticulous </td>
                        <td className='w-150'><input type='checkbox' id='cbDRESS_5' name='cbDRESS_5' className='add-only' value='Not Assessed ' /> Not Assessed </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>ATTITUDE/INTERVIEW BEHAVIOR</span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbATTITUDE_1' name='cbATTITUDE_1' className='add-only' value=' Cooperative' /> Cooperative </td>
                        <td className='w-150'><input type='checkbox' id='cbATTITUDE_2' name='cbATTITUDE_2' className='add-only' value=' Uncooperative' /> Uncooperative </td>
                        <td className='w-150'><input type='checkbox' id='cbATTITUDE_3' name='cbATTITUDE_3' className='add-only' value=' Defensive' /> Defensive </td>
                        <td className='w-150'><input type='checkbox' id='cbATTITUDE_4' name='cbATTITUDE_4' className='add-only' value=' Hostile' /> Hostile </td>
                        <td className='w-150'><input type='checkbox' id='cbATTITUDE_5' name='cbATTITUDE_5' className='add-only' value=' Guarded' /> Guarded </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbATTITUDE_6' name='cbATTITUDE_6' className='add-only' value=' Apathetic ' /> Apathetic </td>
                        <td className='w-150'><input type='checkbox' id='cbATTITUDE_7' name='cbATTITUDE_7' className='add-only' value=' Appropriate' /> Appropriate </td>
                        <td className='w-150'><input type='checkbox' id='cbATTITUDE_8' name='cbATTITUDE_8' className='add-only' value=' Aggressive' /> Aggressive </td>
                        <td className='w-150'><input type='checkbox' id='cbATTITUDE_9' name='cbATTITUDE_9' className='add-only' value=' Argumentative' /> Argumentative </td>
                        <td className='w-150'><input type='checkbox' id='cbATTITUDE_10' name='cbATTITUDE_10' className='add-only' value=' Child-like' /> Child-like </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbATTITUDE_11' name='cbATTITUDE_11' className='add-only' value=' Evasive ' /> Evasive </td>
                        <td className='w-150'><input type='checkbox' id='cbATTITUDE_12' name='cbATTITUDE_12' className='add-only' value=' Angry' /> Angry </td>
                        <td className='w-150'><input type='checkbox' id='cbATTITUDE_13' name='cbATTITUDE_13' className='add-only' value=' Seductive' /> Seductive </td>
                        <td className='w-150'><input type='checkbox' id='cbATTITUDE_14' name='cbATTITUDE_14' className='add-only' value=' Demanding' /> Demanding </td>
                        <td className='w-150'><input type='checkbox' id='cbATTITUDE_15' name='cbATTITUDE_15' className='add-only' value=' Drastic' /> Drastic </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbATTITUDE_16' name='cbATTITUDE_16' className='add-only' value=' Irritable ' /> Irritable </td>
                        <td className='w-150'><input type='checkbox' id='cbATTITUDE_17' name='cbATTITUDE_17' className='add-only' value=' Manipulative' /> Manipulative </td>
                        <td className='w-150'><input type='checkbox' id='cbATTITUDE_18' name='cbATTITUDE_18' className='add-only' value=' Passive' /> Passive </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>SPEECH</span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbSPEECH_1' name='cbSPEECH_1' className='add-only' value=' Normal' /> Normal </td>
                        <td className='w-150'><input type='checkbox' id='cbSPEECH_2' name='cbSPEECH_2' className='add-only' value=' Spontaneous' /> Spontaneous </td>
                        <td className='w-150'><input type='checkbox' id='cbSPEECH_3' name='cbSPEECH_3' className='add-only' value=' Impoverished' /> Impoverished </td>
                        <td className='w-150'><input type='checkbox' id='cbSPEECH_4' name='cbSPEECH_4' className='add-only' value=' Soft' /> Soft </td>
                        <td className='w-150'><input type='checkbox' id='cbSPEECH_5' name='cbSPEECH_5' className='add-only' value=' Whispered' /> Whispered </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbSPEECH_6' name='cbSPEECH_6' className='add-only' value=' Hesitant ' /> Hesitant </td>
                        <td className='w-150'><input type='checkbox' id='cbSPEECH_7' name='cbSPEECH_7' className='add-only' value=' Slowed' /> Slowed </td>
                        <td className='w-150'><input type='checkbox' id='cbSPEECH_8' name='cbSPEECH_8' className='add-only' value=' Mumbled' /> Mumbled </td>
                        <td className='w-150'><input type='checkbox' id='cbSPEECH_9' name='cbSPEECH_9' className='add-only' value=' Pressured' /> Pressured </td>
                        <td className='w-150'><input type='checkbox' id='cbSPEECH_10' name='cbSPEECH_10' className='add-only' value=' Impediment' /> Impediment </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbSPEECH_11' name='cbSPEECH_11' className='add-only' value=' Stuttering ' /> Stuttering </td>
                        <td className='w-150'><input type='checkbox' id='cbSPEECH_12' name='cbSPEECH_12' className='add-only' value=' Verbose' /> Verbose </td>
                        <td className='w-150'><input type='checkbox' id='cbSPEECH_13' name='cbSPEECH_13' className='add-only' value=' Monotonous' /> Monotonous </td>
                        <td className='w-150'><input type='checkbox' id='cbSPEECH_14' name='cbSPEECH_14' className='add-only' value=' Slow' /> Slow </td>
                        <td className='w-150'><input type='checkbox' id='cbSPEECH_15' name='cbSPEECH_15' className='add-only' value=' Rapid' /> Rapid </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbSPEECH_16' name='cbSPEECH_16' className='add-only' value=' Loud ' /> Loud </td>
                        <td className='w-150'><input type='checkbox' id='cbSPEECH_17' name='cbSPEECH_17' className='add-only' value=' Mute' /> Mute </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>MOOD</span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbMOOD_1' name='cbMOOD_1' className='add-only' value=' Dysphoric' /> Dysphoric </td>
                        <td className='w-150'><input type='checkbox' id='cbMOOD_2' name='cbMOOD_2' className='add-only' value=' Euthymic' /> Euthymic </td>
                        <td className='w-150'><input type='checkbox' id='cbMOOD_3' name='cbMOOD_3' className='add-only' value=' Expansive' /> Expansive </td>
                        <td className='w-150'><input type='checkbox' id='cbMOOD_4' name='cbMOOD_4' className='add-only' value=' Irritable' /> Irritable </td>
                        <td className='w-150'><input type='checkbox' id='cbMOOD_5' name='cbMOOD_5' className='add-only' value=' Labile' /> Labile </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbMOOD_6' name='cbMOOD_6' className='add-only' value=' Elevated ' /> Elevated </td>
                        <td className='w-150'><input type='checkbox' id='cbMOOD_7' name='cbMOOD_7' className='add-only' value=' Euphoric' /> Euphoric </td>
                        <td className='w-150'><input type='checkbox' id='cbMOOD_8' name='cbMOOD_8' className='add-only' value=' Ecstatic' /> Ecstatic </td>
                        <td className='w-150'><input type='checkbox' id='cbMOOD_9' name='cbMOOD_9' className='add-only' value=' Depressed' /> Depressed </td>
                        <td className='w-150'><input type='checkbox' id='cbMOOD_10' name='cbMOOD_10' className='add-only' value=' Grief/Mourning' /> Grief/Mourning </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbMOOD_11' name='cbMOOD_11' className='add-only' value=' Alexi thymic ' /> Alexi thymic </td>
                        <td className='w-150'><input type='checkbox' id='cbMOOD_12' name='cbMOOD_12' className='add-only' value=' Elated' /> Elated </td>
                        <td className='w-150'><input type='checkbox' id='cbMOOD_13' name='cbMOOD_13' className='add-only' value=' Hypomanic' /> Hypomanic </td>
                        <td className='w-150'><input type='checkbox' id='cbMOOD_14' name='cbMOOD_14' className='add-only' value=' Manic' /> Manic </td>
                        <td className='w-150'><input type='checkbox' id='cbMOOD_15' name='cbMOOD_15' className='add-only' value=' Anxious' /> Anxious </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbMOOD_16' name='cbMOOD_16' className='add-only' value=' Loud ' /> Other </td>
                        <td className='w-150'><input type='checkbox' id='cbMOOD_17' name='cbMOOD_17' className='add-only' value=' Mute' /> Tense </td>
                        <td className='w-150'><input type='checkbox' id='cbMOOD_18' name='cbMOOD_18' className='add-only' value=' Mute' /> Grandiose </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>AFFECT</span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbAFFECT_1' name='cbAFFECT_1' className='add-only' value=' Appropriate' /> Appropriate </td>
                        <td className='w-150'><input type='checkbox' id='cbAFFECT_2' name='cbAFFECT_2' className='add-only' value=' Inappropriate' /> Inappropriate </td>
                        <td className='w-150'><input type='checkbox' id='cbAFFECT_3' name='cbAFFECT_3' className='add-only' value=' Blunted' /> Blunted </td>
                        <td className='w-150'><input type='checkbox' id='cbAFFECT_4' name='cbAFFECT_4' className='add-only' value=' Restricted' /> Restricted </td>
                        <td className='w-150'><input type='checkbox' id='cbAFFECT_5' name='cbAFFECT_5' className='add-only' value=' Flat' /> Flat </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbAFFECT_6' name='cbAFFECT_6' className='add-only' value=' Labile ' /> Labile </td>
                        <td className='w-150'><input type='checkbox' id='cbAFFECT_7' name='cbAFFECT_7' className='add-only' value=' Tearful' /> Tearful </td>
                        <td className='w-150'><input type='checkbox' id='cbAFFECT_8' name='cbAFFECT_8' className='add-only' value=' Intense' /> Intense </td>
                        <td className='w-150'><input type='checkbox' id='cbAFFECT_9' name='cbAFFECT_9' className='add-only' value=' Congruent' /> Congruent </td>
                        <td className='w-150'><input type='checkbox' id='cbAFFECT_10' name='cbAFFECT_10' className='add-only' value=' Incongruent' /> Incongruent </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbAFFECT_11' name='cbAFFECT_11' className='add-only' value=' Reactive ' /> Reactive </td>
                        <td className='w-150'><input type='checkbox' id='cbAFFECT_12' name='cbAFFECT_12' className='add-only' value=' Constricted' /> Constricted </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>INSIGHT</span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbINSIGHT_1' name='cbINSIGHT_1' className='add-only' value=' Excellent' /> Excellent </td>
                        <td className='w-150'><input type='checkbox' id='cbINSIGHT_2' name='cbINSIGHT_2' className='add-only' value=' Good' /> Good </td>
                        <td className='w-150'><input type='checkbox' id='cbINSIGHT_3' name='cbINSIGHT_3' className='add-only' value=' Poor' /> Poor </td>
                        <td className='w-150'><input type='checkbox' id='cbINSIGHT_4' name='cbINSIGHT_4' className='add-only' value=' Nil' /> Nil </td>
                        <td className='w-150'><input type='checkbox' id='cbINSIGHT_5' name='cbINSIGHT_5' className='add-only' value=' Denial' /> Denial </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbINSIGHT_6' name='cbINSIGHT_6' className='add-only' value=' Other' /> Other </td>
                        <td className='w-150'><input type='checkbox' id='cbINSIGHT_7' name='cbINSIGHT_7' className='add-only' value=' Impaired insight' /> Impaired insight </td>
                        <td className='w-400'><input type='checkbox' id='cbINSIGHT_8' name='cbINSIGHT_8' className='add-only' value=' Fair/Some awareness of illness/Symptoms' /> Fair/Some awareness of illness/Symptoms </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>JUDGMENT/IMPULSE CONTROL</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbJUDGMENT_1' name='cbJUDGMENT_1' className='add-only' value=' Critical Judgment Intact' /> Critical Judgment Intactellent </td>
                        <td className='w-250'><input type='checkbox' id='cbJUDGMENT_2' name='cbJUDGMENT_2' className='add-only' value=' Impaired Judgment' /> Impaired Judgment </td>
                        <td className='w-250'><input type='checkbox' id='cbJUDGMENT_3' name='cbJUDGMENT_3' className='add-only' value=' Able to Resist Impulses' /> Able to Resist Impulses </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbJUDGMENT_4' name='cbJUDGMENT_4' className='add-only' value=' Recent Impulsive Behavior' /> Recent Impulsive Behavior </td>
                        <td className='w-250'><input type='checkbox' id='cbJUDGMENT_5' name='cbJUDGMENT_5' className='add-only' value=' Impaired impulse Control' /> Impaired impulse Control </td>
                        <td className='w-250'><input type='checkbox' id='cbJUDGMENT_6' name='cbJUDGMENT_6' className='add-only' value=' Present' /> Present </td>

                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbJUDGMENT_7' name='cbJUDGMENT_7' className='add-only' value=' Compulsions' /> Compulsions </td>
                        <td className='w-400'><input type='checkbox' id='cbJUDGMENT_8' name='cbJUDGMENT_8' className='add-only' value=' None' /> None </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>MEMORY</span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbMEMORY_1' name='cbMEMORY_1' className='add-only' value=' Normal' /> Normal </td>
                        <td className='w-150'><input type='checkbox' id='cbMEMORY_2' name='cbMEMORY_2' className='add-only' value=' Impaired' /> Impaired</td>
                        <td className='w-150'><input type='checkbox' id='cbMEMORY_3' name='cbMEMORY_3' className='add-only' value=' Intact' /> Intact </td>
                        <td className='w-150'><input type='checkbox' id='cbMEMORY_4' name='cbMEMORY_4' className='add-only' value=' Poor Remote' /> Poor Remote </td>
                        <td className='w-150'><input type='checkbox' id='cbMEMORY_5' name='cbMEMORY_5' className='add-only' value=' Poor Recent' /> Poor Recent </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbMEMORY_6' name='cbMEMORY_6' className='add-only' value=' Other' /> Other:
                            &nbsp;
                            <input type='text' id='txtOther_5' name='txtOther_5' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>THOUGHT PROCESS</span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbTHOUGHTPROCESS_1' name='cbTHOUGHTPROCESS_1' className='add-only' value=' Logical/Coherent' /> Logical/Coherent </td>
                        <td className='w-150'><input type='checkbox' id='cbTHOUGHTPROCESS_2' name='cbTHOUGHTPROCESS_2' className='add-only' value=' Incomprehensible' /> Incomprehensible</td>
                        <td className='w-150'><input type='checkbox' id='cbTHOUGHTPROCESS_3' name='cbTHOUGHTPROCESS_3' className='add-only' value=' Incoherent' /> Incoherent </td>
                        <td className='w-150'><input type='checkbox' id='cbTHOUGHTPROCESS_4' name='cbTHOUGHTPROCESS_4' className='add-only' value=' Flight of ideas' /> Flight of ideas </td>
                        <td className='w-150'><input type='checkbox' id='cbTHOUGHTPROCESS_5' name='cbTHOUGHTPROCESS_5' className='add-only' value=' Loose Association' /> Loose Association </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbTHOUGHTPROCESS_6' name='cbTHOUGHTPROCESS_6' className='add-only' value=' Tangential' /> Tangential </td>
                        <td className='w-150'><input type='checkbox' id='cbTHOUGHTPROCESS_7' name='cbTHOUGHTPROCESS_7' className='add-only' value=' Circumstantial' /> Circumstantial</td>
                        <td className='w-150'><input type='checkbox' id='cbTHOUGHTPROCESS_8' name='cbTHOUGHTPROCESS_8' className='add-only' value=' Rambling' /> Rambling </td>
                        <td className='w-150'><input type='checkbox' id='cbTHOUGHTPROCESS_9' name='cbTHOUGHTPROCESS_9' className='add-only' value=' Evasive' /> Evasive </td>
                        <td className='w-150'><input type='checkbox' id='cbTHOUGHTPROCESS_10' name='cbTHOUGHTPROCESS_10' className='add-only' value=' Racing Thoughts' /> Racing Thoughts </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbTHOUGHTPROCESS_11' name='cbTHOUGHTPROCESS_11' className='add-only' value=' Perseveration' /> Perseveration </td>
                        <td className='w-150'><input type='checkbox' id='cbTHOUGHTPROCESS_12' name='cbTHOUGHTPROCESS_12' className='add-only' value=' Thought blocking' /> Thought blocking</td>
                        <td className='w-150'><input type='checkbox' id='cbTHOUGHTPROCESS_13' name='cbTHOUGHTPROCESS_13' className='add-only' value=' Concrete' /> Concrete </td>
                        <td className='w-150'><input type='checkbox' id='cbTHOUGHTPROCESS_14' name='cbTHOUGHTPROCESS_14' className='add-only' value=' Unremarkable' /> Unremarkable </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>THOUGHT CONTENT</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbTHOUGHTCONTENT_1' name='cbTHOUGHTCONTENT_1' className='add-only' value=' Appropriate' /> Appropriate </td>
                        <td className='w-250'><input type='checkbox' id='cbTHOUGHTCONTENT_2' name='cbTHOUGHTCONTENT_2' className='add-only' value=' Consistent with Age' /> Consistent with Age</td>
                        <td className='w-250'><input type='checkbox' id='cbTHOUGHTCONTENT_3' name='cbTHOUGHTCONTENT_3' className='add-only' value=' Preoccupations' /> Preoccupations </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbTHOUGHTCONTENT_4' name='cbTHOUGHTCONTENT_4' className='add-only' value=' Obsessions' /> Obsessions </td>
                        <td className='w-250'><input type='checkbox' id='cbTHOUGHTCONTENT_5' name='cbTHOUGHTCONTENT_5' className='add-only' value=' Compulsions' /> Compulsions </td>
                        <td className='w-250'><input type='checkbox' id='cbTHOUGHTCONTENT_6' name='cbTHOUGHTCONTENT_6' className='add-only' value=' Phobias' /> Phobias </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbTHOUGHTCONTENT_7' name='cbTHOUGHTCONTENT_7' className='add-only' value=' Thought Broadcasting' /> Thought Broadcasting</td>
                        <td className='w-250'><input type='checkbox' id='cbTHOUGHTCONTENT_8' name='cbTHOUGHTCONTENT_8' className='add-only' value=' Thought Insertion' /> Thought Insertion </td>
                        <td className='w-250'><input type='checkbox' id='cbTHOUGHTCONTENT_9' name='cbTHOUGHTCONTENT_9' className='add-only' value=' Thought Withdrawal' /> Thought Withdrawal </td>

                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbTHOUGHTCONTENT_10' name='cbTHOUGHTCONTENT_10' className='add-only' value=' Ideas of Reference' /> Ideas of Reference </td>
                        <td className='w-250'><input type='checkbox' id='cbTHOUGHTCONTENT_11' name='cbTHOUGHTCONTENT_11' className='add-only' value=' Ideas of Influence' /> Ideas of Influence</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbTHOUGHTCONTENT_12' name='cbTHOUGHTCONTENT_12' className='add-only' value=' Other' /> Other:
                            &nbsp;
                            <input type='text' id='txtOther_6' name='txtOther_6' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>DEVELOPMENTAL HISTORY:</b>
                    <span className='small'>(walking, talking, reading, running)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>GROWTH & DEVELOPMENT:</span></td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='checkbox' id='cbDEVELOPMENT_1' name='cbDEVELOPMENT_1' className='add-only' value=' WNL' />  WNL </td>
                        <td className='w-375'><input type='checkbox' id='cbDEVELOPMENT_2' name='cbDEVELOPMENT_2' className='add-only' value=' ABNORMAL/DELAYS, if any' />  ABNORMAL/DELAYS, if any </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>DESCRIBE:</span>
                    <textarea id='txtDESCRIBE' name='txtDESCRIBE' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <b>MEDICAL HISTORY:</b>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> CURRENT ILLNESSES: </span>
                    <textarea id='txtCURRENTILLNESSES' name='txtCURRENTILLNESSES' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>PAST ILLNESSES:</span>
                    <textarea id='txtPASTILLNESSES' name='txtPASTILLNESSES' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>ALLERGIES: </span>
                    <textarea id='txtALLERGIES' name='txtALLERGIES' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>CURRENT NON PSYCHIATRIC MEDS: </span>
                    <textarea id='txtCURRENTNONPSYCHIATRIC' name='txtCURRENTNONPSYCHIATRIC' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>HISTORY of ABUSE or TRAUMA <i>(witnessed or experienced)</i></span>
                    <textarea id='txtHISTORYofABUSE' name='txtHISTORYofABUSE' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <b>SAFETY RISKS:</b>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>RISK of HARM:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbRISKofHARM_1' name='cbRISKofHARM_1' className='add-only' value=' NO HARM/EVIDENCE' /> NO HARM/EVIDENCE</td>
                        <td className='w-250'><input type='checkbox' id='cbRISKofHARM_2' name='cbRISKofHARM_2' className='add-only' value=' TO SELF' />  TO SELF </td>
                        <td className='w-250'><input type='checkbox' id='cbRISKofHARM_3' name='cbRISKofHARM_3' className='add-only' value='TO OTHERS' />  TO OTHERS </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>DESCRIBE:</span>
                    <textarea id='txtDESCRIBE_1' name='txtDESCRIBE_1' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'> DELUSIONS </span> </td>
                    </tr>
                    <tr>
                        <td className='w-125'><input type='checkbox' id='cbDELUSIONS_1' name='cbDELUSIONS_1' className='add-only' value='NONE' /> NONE</td>
                        <td className='w-125'><input type='checkbox' id='cbDELUSIONS_2' name='cbDELUSIONS_2' className='add-only' value='Persecutory' /> Persecutory</td>
                        <td className='w-125'><input type='checkbox' id='cbDELUSIONS_3' name='cbDELUSIONS_3' className='add-only' value='Bizarre' /> Bizarre</td>
                        <td className='w-125'><input type='checkbox' id='cbDELUSIONS_4' name='cbDELUSIONS_4' className='add-only' value='Grandeur' /> Grandeur</td>
                        <td className='w-125'><input type='checkbox' id='cbDELUSIONS_5' name='cbDELUSIONS_5' className='add-only' value='Guilt' /> Guilt</td>
                        <td className='w-125'><input type='checkbox' id='cbDELUSIONS_6' name='cbDELUSIONS_6' className='add-only' value='Somatic' /> Somatic</td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'> HALLUCINATIONS </span> </td>
                    </tr>
                    <tr>
                        <td className='w-125'><input type='checkbox' id='cbHALLUCINATIONS_1' name='cbHALLUCINATIONS_1' className='add-only' value='NONE' /> NONE</td>
                        <td className='w-125'><input type='checkbox' id='cbHALLUCINATIONS_2' name='cbHALLUCINATIONS_2' className='add-only' value='Auditory' /> Auditory</td>
                        <td className='w-125'><input type='checkbox' id='cbHALLUCINATIONS_3' name='cbHALLUCINATIONS_3' className='add-only' value='Olfactory' /> Olfactory</td>
                        <td className='w-125'><input type='checkbox' id='cbHALLUCINATIONS_4' name='cbHALLUCINATIONS_4' className='add-only' value='Tactile' /> Tactile</td>
                        <td className='w-125'><input type='checkbox' id='cbHALLUCINATIONS_5' name='cbHALLUCINATIONS_5' className='add-only' value='Gustatory' /> Gustatory</td>
                        <td className='w-125'><input type='checkbox' id='cbHALLUCINATIONS_6' name='cbHALLUCINATIONS_6' className='add-only' value='Not Assessed' /> Not Assessed</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>PSYCHIATRIC HISTORY:</b>
                    <span className='eleHeader'> HISTORY of EMOTIONAL and/or BEHAVIORAL PROBLEMS</span>
                    <textarea id='txtorBEHAVIORALPROBLEMS' name='txtorBEHAVIORALPROBLEMS' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-125'><input type='checkbox' id='cdHISTORYofEMOTIONAL_1' name='cdHISTORYofEMOTIONAL_1' className='add-only' value='CURRENT' /> CURRENT</td>
                        <td className='w-125'><input type='checkbox' id='cdHISTORYofEMOTIONAL_2' name='cdHISTORYofEMOTIONAL_2' className='add-only' value='PAST' /> PAST</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id='txtHISTORYofEMOTIONALs' name='txtHISTORYofEMOTIONALs' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-125'><input type='checkbox' id='cdHISTORYofEMOTIONAL_3' name='cdHISTORYofEMOTIONAL_3' className='add-only' value='CURRENT' /> CURRENT</td>
                        <td className='w-125'><input type='checkbox' id='cdHISTORYofEMOTIONAL_4' name='cdHISTORYofEMOTIONAL_4' className='add-only' value='PAST' /> PAST</td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>MEDICATION(s) EFFECTIVE:</span></td>
                    </tr>
                    <tr>
                        <td className='w-125'> <input type='radio' id='rbMEDICATION_Yes' name='rbMEDICATION' className='add-only' value='0' /> Yes </td>
                        <td className='w-125'> <input type='radio' id='rbMEDICATION_No' name='rbMEDICATION' className='add-only' value='1' /> No </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>SIDE EFFECTS:</span></td>
                    </tr>
                    <tr>
                        <td className='w-125'> <input type='radio' id='rbSIDEEFFECTS_Yes' name='rbSIDEEFFECTS' className='add-only' value='0' /> Yes </td>
                        <td className='w-125'> <input type='radio' id='rbSIDEEFFECTS_No' name='rbSIDEEFFECTS' className='add-only' value='1' /> None </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Describe:</b>
                    <textarea id='txtDescribe_2' name='txtDescribe_2' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>HISTORY of OUTPATIENT MENTAL HEALTH TREATMENT</span></td>
                    </tr>
                    <tr>
                        <td className='w-125'> <input type='radio' id='rbHEALTHTREATMENT_None' name='rbHEALTHTREATMENT' className='add-only' value='0' /> None </td>
                        <td className='w-125'> <input type='radio' id='rbHEALTHTREATMENT_Past' name='rbHEALTHTREATMENT' className='add-only' value='1' /> Past </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Diagnosis:</b>
                    <textarea id='txtDescribe_3' name='txtDescribe_3' className='add-only'></textarea>
                    <b>Provider:</b>
                    <textarea id='txtProvider_1' name='txtProvider_1' className='add-only'></textarea>

                    <span className='eleHeader'>RESPONSE TO PREVIOUS TREATMENT:</span>
                    <textarea id='txtMedicalHistory' name='txtMedicalHistory' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>  HISTORY of SUBSTANCE ABUSE: <i>(If checked, potential adverse effects addressed/discussed)</i></span> </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cdHISTORYofSUBSTANCEABUSE_1' name='cdHISTORYofSUBSTANCEABUSE_1' className='add-only' value='NONE' /> NONE</td>
                        <td className='w-187'><input type='checkbox' id='cdHISTORYofSUBSTANCEABUSE_2' name='cdHISTORYofSUBSTANCEABUSE_2' className='add-only' value='CURRENT' /> CURRENT</td>
                        <td className='w-187'><input type='checkbox' id='cdHISTORYofSUBSTANCEABUSE_3' name='cdHISTORYofSUBSTANCEABUSE_3' className='add-only' value='PAST' /> PAST</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cdHISTORYofSUBSTANCEABUSE_4' name='cdHISTORYofSUBSTANCEABUSE_4' className='add-only' value='Illicit Drug Use' /> Illicit Drug Use</td>
                        <td className='w-187'><input type='checkbox' id='cdHISTORYofSUBSTANCEABUSE_5' name='cdHISTORYofSUBSTANCEABUSE_5' className='add-only' value='Alcohol Use' /> Alcohol Use</td>
                        <td className='w-187'><input type='checkbox' id='cdHISTORYofSUBSTANCEABUSE_6' name='cdHISTORYofSUBSTANCEABUSE_6' className='add-only' value='OTC' /> OTC</td>
                        <td className='w-187'><input type='checkbox' id='cdHISTORYofSUBSTANCEABUSE_7' name='cdHISTORYofSUBSTANCEABUSE_7' className='add-only' value='Herbal Meds' /> Herbal Meds</td>
                    </tr>

                    <tr>
                        <td className='w-200'> <span className='eleHeader'> Age of 1st use:</span> </td>
                        <td className='w-550'> <span className='eleHeader'>Referral today:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-200'> <input type='text' id='txtAgeofuse' name='txtAgeofuse' className='add-only' /> </td>
                        <td className='w-550'> <input type='text' id='txtReferraltoday' name='txtReferraltoday' className='add-only' /> </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>LEGAL/CRIMINAL/HISTORY:</span>
                    <textarea id='txtLEGALCRIMINAL' name='txtLEGALCRIMINAL' className='add-only'></textarea>

                    <span className='eleHeader'>SIGNIFICANT FAMILY MEDICAL and/or PSYCHIATRIC HISTORY:</span>
                    <textarea id='txtorPSYCHIATRICHISTOR' name='txtorPSYCHIATRICHISTOR' className='add-only'></textarea>
 
                </p>
                <p className='w-750'>
                    <h3>DIAGNOSIS:</h3>  


                    <span className='eleHeader'>Primary:</span>
                    <textarea id='txtDIAGNOSIS_1' name='txtDIAGNOSIS_1' className='add-only'></textarea> <br /> 
                    
                    <span className='eleHeader'>Secondary:</span>
                    <textarea id='txtDIAGNOSIS_2' name='txtDIAGNOSIS_2' className='add-only'></textarea> <br />
                    
                    <span className='eleHeader'>Tertiary:</span>
                    <textarea id='txtDIAGNOSIS_3' name='txtDIAGNOSIS_3' className='add-only'></textarea> <br />
                    
                    <span className='eleHeader'>Additional:</span>
                    <textarea id='txtDIAGNOSIS_4' name='txtDIAGNOSIS_4' className='add-only'></textarea> <br /> 
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>SUPPORTING DSM-V DIAGNOSTIC CRITERIA:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-20'>(1). </td>
                        <td className='w-730'> <input type='text' id='txDIAGNOSTICCRITERIA_1' name='txDIAGNOSTICCRITERIA_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-20'>(2). </td>
                        <td className='w-730'> <input type='text' id='txDIAGNOSTICCRITERIA_2' name='txDIAGNOSTICCRITERIA_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-20'>(3). </td>
                        <td className='w-730'> <input type='text' id='txDIAGNOSTICCRITERIA_3' name='txDIAGNOSTICCRITERIA_3' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-20'>(4). </td>
                        <td className='w-730'> <input type='text' id='txDIAGNOSTICCRITERIA_4' name='txDIAGNOSTICCRITERIA_4' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-20'>(5). </td>
                        <td className='w-730'> <input type='text' id='txDIAGNOSTICCRITERIA_5' name='txDIAGNOSTICCRITERIA_5' className='add-only' /> </td>
                    </tr>
                </table>
                <table>


                    <tr>
                        <td className='w-750'> <span className='eleHeader'>TREATMENT PLAN: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> 1. MED </td>
                        <td className='w-375'> (Indication for use): </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtMED_1' name='txtMED_1' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtIndicationforuse_1' name='txtIndicationforuse_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> MED </td>
                        <td className='w-375'> (Indication for use): </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtMED_2' name='txtMED_2' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtIndicationforuse_2' name='txtIndicationforuse_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> MED </td>
                        <td className='w-375'> (Indication for use): </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtMED_3' name='txtMED_3' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtIndicationforuse_3' name='txtIndicationforuse_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> MED </td>
                        <td className='w-375'>  (Indication for use): </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtMED_4' name='txtMED_4' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtIndicationforuse_4' name='txtIndicationforuse_4' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> 2. INDIVIDUAL COUNSELING with CPST/PSR per the ESTABLISHED TREATMENT PLAN</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            3. RTC &nbsp;
                            <input type='text' id='txtRTC' name='txtRTC' className='add-only w-250 custom-add-only' /> &nbsp; MONTH (s)/ or PRN
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>NURSING</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            BLOOD PRESSURE: &nbsp;
                            <input type='text' id='txtBLOODPRESSURE_1' name='txtBLOODPRESSURE_1' className='add-only w-100 custom-add-only' /> / &nbsp;
                            <input type='text' id='txtBLOODPRESSURE_2' name='txtBLOODPRESSURE_2' className='add-only w-100 custom-add-only' />   &nbsp;
                            WEIGHT: &nbsp;
                            <input type='text' id='txtWEIGHT' name='txtWEIGHT' className='add-only w-100 custom-add-only' /> lbs.
                        </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> RN Signature:</td>
                        <td className='small w-375'> Date: </td>
                    </tr>
                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-750'> 
                        PSYCHIATRIST SIGNATURE: 
                        </td> 
                    </tr>
                </table>






            </div>
        </form>

    )
}